<template>
  <div class="row">
    <div class="col col-md-10 offset-md-1 text-center">
      <div class="d-flex justify-content-between">
        <Combo
          :itens="$global.sites_filtro_completo()"
          v-model="filtroSite"
          style="max-width: 150px; margin-right: 10px"
          v-if="
            retornaSite() !== 'Share' &&
            retornaSite() !== 'Stream1x2' &&
            retornaSite() !== '7live'
          "
        />

        <input
          class="form-control"
          style="margin-right: 10px"
          type="text"
          placeholder="Email..."
          v-model="filtroUsuario"
        />

        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          style
          @click="carregarItens()"
        >
          Filtrar
        </button>
      </div>

      <hr />

      <div class="rowLista">
        <div class="list-group-item list-group-item-dark text-left">
          <div class="row">
            <div class="col">
              <h5 style="margin-top: 9px">#</h5>
            </div>
            <div class="col col-md-3 text-center">
              <h5 style="margin-top: 9px">Usuários</h5>
            </div>
            <div class="col col-md-3 text-center">
              <h5 style="margin-top: 9px">Sessões</h5>
            </div>
          </div>
        </div>
        <div
          class="list-group-item list-group-item-action text-left"
          v-for="item in itens"
          :key="item._id"
          :item="item"
          @click="clicouEvento(item._id)"
          style="cursor: pointer"
        >
          <div class="row">
            <div class="col">
              <h5 style="margin-top: 9px" v-if="propView == 'evento'">
                {{ itensEventos[item._id] }}
              </h5>
              <h5
                style="margin-top: 9px"
                v-if="
                  propView == 'servidor' &&
                  $global.servidores_sip()[
                    item.servidorTipo + '_' + item.servidor
                  ]
                "
              >
                {{
                  $global.servidores_sip()[
                    item.servidorTipo + "_" + item.servidor
                  ].nome
                }}
              </h5>
              <div v-if="propView == 'evento'">
                <h6
                  v-for="itemServidor in item.servidores"
                  :key="itemServidor._id"
                  :item="itemServidor"
                  class="text-secondary"
                  style="margin-top: 9px"
                >
                  Canal {{ itemServidor.canal }} -
                  {{
                    $global.servidores_sip()[
                      itemServidor.servidorTipo + "_" + itemServidor.servidor
                    ].nome
                  }}
                </h6>
              </div>
              <div v-if="propView == 'servidor'">
                <h6
                  v-for="itemEvento in item.eventos"
                  :key="itemEvento._id"
                  :item="itemEvento"
                  class="text-secondary"
                  style="margin-top: 9px"
                >
                  (Canal {{ itemEvento.canal }})
                  {{ itensEventos[itemEvento.evento] }}
                </h6>
              </div>
            </div>
            <div class="col col-md-3 text-center">
              <h5 v-if="propView == 'evento'" style="margin-top: 9px">
                {{ item.sessoesUsuario }}
              </h5>
              <h5 v-if="propView == 'servidor'" style="margin-top: 9px">-</h5>
              <div v-if="propView == 'evento'">
                <h6
                  v-for="itemServidor in item.servidores"
                  :key="itemServidor._id"
                  :item="itemServidor"
                  class="text-secondary"
                  style="margin-top: 9px"
                >
                  -
                </h6>
              </div>
              <div v-if="propView == 'servidor'">
                <h6
                  v-for="itemEvento in item.eventos"
                  :key="itemEvento._id"
                  :item="itemEvento"
                  class="text-secondary"
                  style="margin-top: 9px"
                >
                  {{ itemEvento.sessoesUsuario }}
                </h6>
              </div>
            </div>
            <div class="col col-md-3 text-center">
              <h5 style="margin-top: 9px">{{ item.sessoesTotal }}</h5>
              <div v-if="propView == 'evento'">
                <h6
                  v-for="itemServidor in item.servidores"
                  :key="itemServidor._id"
                  :item="itemServidor"
                  class="text-secondary"
                  style="margin-top: 9px"
                >
                  {{ itemServidor.sessoesTotal }}
                </h6>
              </div>
              <div v-if="propView == 'servidor'">
                <h6
                  v-for="itemEvento in item.eventos"
                  :key="itemEvento._id"
                  :item="itemEvento"
                  class="text-secondary"
                  style="margin-top: 9px"
                >
                  {{ itemEvento.sessoesTotal }}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import Combo from "../components/Combo.vue";

export default {
  name: "ListSessaoViewResumoServidor",
  components: { Combo },
  props: {
    itensLimit: { type: Number, default: 10000 },
    propView: { type: String, default: "evento" },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    clicouEvento(id) {
      this.$emit("clicouEvento", id);
    },
    async carregarItens() {
      var filtros = "";
      this.itens = [];

      if (this.filtroEvento !== "") {
        filtros += "?_limit=" + this.itensLimit;

        if (this.filtroUsuario !== "") {
          filtros += "&usuario=" + this.filtroUsuario;
        }

        if (this.filtroSite !== "Todos") {
          filtros += "&site=" + this.filtroSite;
        }

        var response;

        if (this.propView == "evento") {
          response = await api.get("/sessaoView/evento/servidor?" + filtros);
        } else {
          response = await api.get("/sessaoView/servidor/evento?" + filtros);
        }

        api.valid(response.data, this.$router);

        var itensEventos = this.itensEventos;
        var propView = this.propView;

        var resultItens = Object.values(response.data.itens).filter(function (
          item
        ) {
          //item.sessoesUsuario = 0;
          //item.sessoesTotal = 0;

          if (propView == "evento") {
            /*
            for(var indiceServidor = 0;indiceServidor < item.servidores.length;indiceServidor++)
            {
              var servidor = item.servidores[indiceServidor];

              //item.sessoesUsuario = item.sessoesUsuario + servidor.sessoesUsuario;
              item.sessoesTotal = item.sessoesTotal + servidor.sessoesTotal;

            }
            */
            item.servidores = Object.values(item.servidores);
            item.servidores.sort((a, b) => b.sessoesTotal - a.sessoesTotal);

            return itensEventos[item._id];
          } else {
            var arrEventos = [];

            for (var propEvento in item.eventos) {
              var evento = item.eventos[propEvento];

              if (itensEventos[evento.evento]) {
                arrEventos.push(evento);
              } else {
                item.sessoesTotal = item.sessoesTotal - evento.sessoesTotal;
              }
            }

            item.eventos = arrEventos;
            item.eventos.sort((a, b) => b.sessoesTotal - a.sessoesTotal);

            return true;
          }
        });

        resultItens.sort((a, b) => b.sessoesTotal - a.sessoesTotal);

        this.itens = resultItens;
      }
    },
    async carregarItensEventos() {
      var filtros = "";

      filtros += "?_limit=500";

      const response = await api.get("/evento" + filtros);
      api.valid(response.data, this.$router);

      this.itensEventos = {};

      for (
        var indiceEvento = 0;
        indiceEvento < response.data.itens.length;
        indiceEvento++
      ) {
        var evento = response.data.itens[indiceEvento];

        //this.itensEventos.push({ id: evento._id, nome: evento.nome });
        this.itensEventos[evento._id] = evento.nome;
      }

      this.carregarItens();
    },
    formatDateTime(datetime) {
      if (!datetime) return null;
      if (datetime && datetime != null && datetime != "") {
        var options = {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          //timeZoneName: "short",
          //timeZone: "UTC"
        };
        datetime = new Date(datetime);
        var portugueseTime = new Intl.DateTimeFormat(
          ["pt-BR", "pt-PT"],
          options
        );
        return portugueseTime.format(datetime);
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.carregarItensEventos();
  },
  data: function () {
    return {
      itens: [],
      itensEventos: {},
      filtroUsuario: "",
      filtroSite: "Todos",
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}
</style>
